import './assets/main.css'

import { createSSRApp } from 'vue'
import App from './App.vue'
import { applyMeta, localeFromPath, makeI18n } from './i18n'

// createSSRApp: в проде гидратируем пререндеренную статику (H-71),
// в dev — обычный mount в пустой #app. Локаль — из URL (/ | /uz/ | /en/).
const lang = localeFromPath(window.location.pathname)
createSSRApp(App).use(makeI18n(lang)).mount('#app')
applyMeta(lang)
